var _path, _g, _path2, _path3, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdaptiveContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3905_40)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3905_40",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H36V36H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3905_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.67261 1.67252L8.78915 8.78906",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78906 5.27344V8.78906H5.27344",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3905_40",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H36V36H0V3.8147e-06Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3905_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8359 12.4453H22.9922C21.8272 12.4453 20.8828 13.3898 20.8828 14.5547V32.8359C20.8828 34.0009 21.8272 34.9453 22.9922 34.9453H32.8359C34.0009 34.9453 34.9453 34.0009 34.9453 32.8359V14.5547C34.9453 13.3898 34.0009 12.4453 32.8359 12.4453Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8828 26.3672H14.4844V30.7266H20.8828V26.3672Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 30.7266H11.6719L10.2656 34.9453H22.9219",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8828 22.1484H1.05469V24.2578C1.05469 25.4228 1.99912 26.3672 3.16406 26.3672H20.8828V22.1484Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9453 14.4141V3.16406C34.9453 1.99905 34.0009 1.05469 32.8359 1.05469H3.16406C1.99912 1.05469 1.05469 1.99905 1.05469 3.16406V22.1484H20.8125",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6172 16.6641V20.1797H25.1016",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5007 13.0631L28.6173 20.1797",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3905_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptiveContent);
export default __webpack_public_path__ + "static/media/adaptive-content.2d981af3feeb5f7a1062ffd6e3b1ecc1.svg";
export { ForwardRef as ReactComponent };